/* eslint-disable no-var */
import OutdatedBrowser from './component';

//
// Using ECMAScript 5 to maximize the support
//

var initWhenTranslationsAreReady = (function () {
  var MAX_WAIT_TIME_SEC = 3;
  var ATTEMPT_TIMEOUT_MS = 100;

  var maxAttempts = (MAX_WAIT_TIME_SEC * 1000) / ATTEMPT_TIMEOUT_MS;
  var attempts = 0;

  return function tryToInit(callback) {
    if (
      (window && window.I18n && window.I18n.translations) ||
      // Init anyway if maximum wait time is exceeded. Use default language string
      attempts > maxAttempts
    ) {
      callback();

      return;
    }

    attempts += 1;
    setTimeout(tryToInit, ATTEMPT_TIMEOUT_MS, callback);
  };
})();

initWhenTranslationsAreReady(OutdatedBrowser.init.bind(OutdatedBrowser));
